import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../lib/i18n';
import RewardDetails from '../../components/reward-details';
import Reward from '../../lib/reward';

export default function RewardItem({ reward, onClick }) {
    return (<li>
        <RewardDetails reward={reward} />

        {(() => {
            if (reward.userCanContactSupport()) {
                return (<footer>
                    <button
                      className="action-button"
                      onClick={onClick}
                    >
                        {t('statusOverview.contactButtonText')}
                    </button>
                </footer>);
            }
            return null;
        })()}
    </li>);
}

RewardItem.propTypes = {
    type: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    reward: Reward.propTypes,
};



// WEBPACK FOOTER //
// ./src/pages/status-overview/reward-item.jsx